import type {AxiosPromise} from 'axios'
import axios, {CancelToken} from '@/plugin/axios'
import api from '@/api'
const cancelFn: Record<string, (reason?: string) => void> = {}

export const documents = {
  fetchBulletins,
  fetchManuals,
  fetchDocumentDownloadLink,
  fetchServiceLetters,
  fetchSchematics,
  fetchSchematicDetails
}

function fetchBulletins(_sn: string, params: Record<string, any>): AxiosPromise {
  if (typeof cancelFn['bulletins'] === 'function') cancelFn['bulletins']('isCancelled')
  return axios.get(api.endpoints.DPMM_API.SERVICE_LIBRARY_BULLETINS.replace('{serial}', _sn), {
    params,
    cancelToken: new CancelToken(function executor(c) { cancelFn['bulletins'] = c })
  })
}

function fetchManuals(_sn: string): AxiosPromise {
  if (typeof cancelFn['manuals'] === 'function') cancelFn['manuals']('isCancelled')
  return axios.get(api.endpoints.DPMM_API.SERVICE_LIBRARY_MANUALS.replace('{serial}', _sn), {
    cancelToken: new CancelToken(function executor(c) { cancelFn['manuals'] = c })
  })
}

function fetchDocumentDownloadLink(_documentId: string): Promise<string> {
  return new Promise((resolve, reject) => {
    axios.get(api.endpoints.DPMM_API.SERVICE_LIBRARY_DOCUMENT_DOWNLOAD.replace('{document_id}', _documentId)).then(r => {
      resolve(r.data.download_link)
    }).catch(r => {
      reject(r.response ? r.response.data.error : {code: '', message: r})
    })
  })
}

function fetchServiceLetters(_fieldModCode: string, lang: string): Promise<string> {
  return new Promise((resolve, reject) => {
    axios.get(api.endpoints.DPMM_API.SERVICE_LIBRARY_LETTERS.replace('{field_mod_code}', _fieldModCode), {
      params: {lang}
    }).then(r => {
      if (r.data.error) reject(r.data.error)
      if (r.data && r.data.download_link) {
        resolve(r.data.download_link)
      } else {
        reject()
      }
    }).catch(r => {
      reject(r.response ? r.response.data.error : {code: '', message: r})
    })
  })
}

function fetchSchematics(serialNumber: string, language: string): AxiosPromise {
  if (typeof cancelFn['schematics'] === 'function') cancelFn['schematics']('isCancelled')

  const requestUrl = api.getEndpoint(api.endpoints.DPMM_API.SCHEMATICS_LIST, {serial: serialNumber})
  const query = api.getQueryString({locale: language})

  return axios.get(requestUrl + query, {
    cancelToken: new CancelToken(function executor(c) { cancelFn['schematics'] = c })
  })
}

function fetchSchematicDetails(sn: string, schematicId: string, locale: string): AxiosPromise {
  return axios.get(
    api.endpoints.DPMM_API.SCHEMATICS_DETAILS.replace('{serial}', sn).replace('{schematic_id}', schematicId),
    {params: {locale}}
  )
}
